import { usePermissions } from '../../../shared/hooks/usePermissions';
import { FEATURES } from '../../../shared/lib/permissions';
import { Collaborator } from '../api';
import { FeriasPainel } from './FeriasPainel';

/** Aba Férias do detalhe do colaborador: Visão 360º pelo RH (US-GP-014). */
export function FeriasTab({ person }: { person: Collaborator }) {
  const { can } = usePermissions();
  return (
    <FeriasPainel
      scope={{ kind: 'rh', userId: person.id }}
      hr={{ canCreate: can(FEATURES.pessoasFerias, 'create'), canEdit: can(FEATURES.pessoasFerias, 'edit') }}
    />
  );
}
